import React from 'react';

import { TextAlignment } from '@candu-ai/editor-nodes/text-settings';
import { Section } from 'craft/containers/Toolbox/components';
import { useCss } from 'craft/hooks';
import { CommonNodeProperties } from 'craft/types';

interface Props {
  nodeIds: string[];
}

export const ListStyles = ({ nodeIds }: Props) => {
  const { css, setCss, stylesHierarchy } = useCss(nodeIds, {
    commonProperty: CommonNodeProperties.Multiple,
  });

  return (
    <Section name="List Styles">
      <TextAlignment cssProps={css} setCss={setCss} stylesHierarchy={stylesHierarchy} />
    </Section>
  );
};
